import { PROP65_WARNING_LINK } from './constant';

export const prop65WarningMsg = (prop65: string) => {
  const linkText = PROP65_WARNING_LINK;
  const prop65Link =
    prop65.includes(linkText) &&
    `<a href=//${linkText} class="text-decoration-underline" target="_blank">${linkText}</a>`;
  return prop65.replace(linkText, prop65Link);
};
